import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=b3d8c422&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=b3d8c422&lang=stylus&scoped=true&"
import style1 from "./Order.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d8c422",
  null
  
)

export default component.exports